import { useEffect } from "react";
import { a11y } from "./NotificationCenter";

export default function DocumentTitle({ title = "" }) {
  useEffect(() => {
    document.title = `Roster Maintenance ${title}`;
    a11y.triggerAlertMessage(`The new page ${title} has loaded.`);
  }, [title]);
  return null;
}
